import {
  Grid,
  GridProps
} from "@mui/material";

import { styled } from "@mui/material/styles";
import {
  TopicCardBody,
  TopicCardContainerStack
} from "../../components/TopicCard/TopicCard.styles";

export const StyledCommentGrid = styled(Grid)<GridProps>(({ theme }) => ({
  display:"flex",
  flexDirection:"column",
  gap: "0.75rem",
  paddingBottom:"80px",

  [`${TopicCardContainerStack}`]:{
    width:"100%"
  },
  [`${TopicCardBody}`]:{
    gap:theme.spacing(1),
    minHeight:"unset"
  },

  [theme.breakpoints.down("sm")]:{
    paddingBottom:"40px"
  }

}));
